// eslint-disable-next-line max-classes-per-file
const q = require('queried');

const {
  View,
  Controller,
} = require('./core');

class TitleController extends Controller {
  sync(data, state) {
    if (typeof data.title !== 'undefined') {
      state.page.title = data.title;
    }

    if (typeof data.description !== 'undefined') {
      state.page.description = data.description;
    }

    return state;
  }
}

/**
 * View for tab and feed title elements.
 */
class Title extends View {
  render(state) {
    if (!state.page) return;

    const title = state.page.title.trim();
    const { description } = state.page;

    if (title) {
      this.setDocumentTitle(title);
      this.setPageH1(title);
    }

    if (description) {
      if (description != title) {
        this.setPageTagline(description);
      } else {
        this.setPageTagline('');
      }
    }
  }

  setDocumentTitle(title) {
    document.title = title;
  }

  setPageH1(title) {
    const h1 = q('.stext h1');
    if (h1) {
      h1.innerHTML = title;
    }
  }

  setPageTagline(text) {
    const tagline = q('.stext-description');

    if (tagline) {
      tagline.innerHTML = text;
    }
  }
}

module.exports = {
  TitleController,
  Title,
};
